export default __webpack_public_path__ + "static/media/eccenaviga1.ccd5b71a.jpg";